export default __webpack_public_path__ + "static/media/office11full.855b2fcd.jpg";